import {
  FaFacebookF,
  FaGoogle,
  FaInstagram,
  FaLinkedinIn,
  FaPinterestP,
  FaTiktok,
  FaTwitter,
  FaVk,
  FaYoutube,
} from "react-icons/fa";
import * as SocialProviders from "../_constants/SocialProvider";
import * as SocialTypes from "../_constants/SocialType";

const socialProviderStyles = {
  [SocialProviders.FACEBOOK]: {
    icon: FaFacebookF,
    background: "facebook.400",
  },
  [SocialProviders.TWITTER]: {
    icon: FaTwitter,
    background: "twitter.400",
  },
  [SocialProviders.GOOGLE]: {
    icon: FaGoogle,
    background: "#4285f4",
  },
  [SocialProviders.YOUTUBE]: {
    icon: FaYoutube,
    background: "#f00",
  },
  [SocialProviders.LINKEDIN]: {
    icon: FaLinkedinIn,
    background: "#525252",
  },
  [SocialProviders.VKONTAKTE]: {
    icon: FaVk,
    background: "#507299",
  },
  [SocialProviders.INSTAGRAM]: {
    icon: FaInstagram,
    background: "#e53c5f",
  },
  [SocialProviders.PINTEREST]: {
    icon: FaPinterestP,
    background: "#bd081c",
  },
  [SocialProviders.TIKTOK]: {
    icon: FaTiktok,
    background: "#000",
  },
};

export const getSocialProviderBySocialType = (socialType) => {
  const socialProviderKey = Object.keys(SocialProviders).find((key) =>
    SocialTypes?.[`ALL_${key}`]?.includes(socialType)
  );

  if (socialProviderKey) {
    return SocialProviders[socialProviderKey];
  }

  return null;
};

export const getSocialProviderStyles = (socialProvider) =>
  socialProviderStyles[socialProvider];
